export default {
    getGroupBases: { method: 'get', url: 'groups/bases' },
    postGroupBases: { method: 'post', url: 'groups/bases' },
    updateGroupBases: { method: 'put', url: 'groups/bases/{id}' },
    deleteGroupBases: { method: 'delete', url: 'groups/bases/{id}' },
}